// We use Google-hosted fonts (not self-hosted). Widgets render inside a shadow
// root, where a stylesheet `@import` doesn't reliably load — but `@font-face`
// declared in the HOST document's <head> DOES apply inside shadow DOM (fonts are
// a document-level resource). So we inject the Google Fonts <link> into the host
// page's <head> once, from both the SPA entry (main.tsx) and every widget mount
// (mountWidget). Idempotent — guarded by the stylesheet's element id.
const FONTS_LINK_ID = "turnago-google-fonts"

const FONTS_HREF =
  "https://fonts.googleapis.com/css2" +
  "?family=Geist:wght@100..900" +
  "&family=Barlow+Condensed:wght@400;500;600;700;800" +
  "&family=Chakra+Petch:wght@300;400;500;600;700" +
  "&display=swap"

export function injectFonts(): void {
  if (typeof document === "undefined") return
  if (document.getElementById(FONTS_LINK_ID)) return

  const preconnect = (href: string, crossOrigin?: boolean) => {
    const link = document.createElement("link")
    link.rel = "preconnect"
    link.href = href
    if (crossOrigin) link.crossOrigin = "anonymous"
    document.head.appendChild(link)
  }
  preconnect("https://fonts.googleapis.com")
  preconnect("https://fonts.gstatic.com", true)

  const stylesheet = document.createElement("link")
  stylesheet.id = FONTS_LINK_ID
  stylesheet.rel = "stylesheet"
  stylesheet.href = FONTS_HREF
  document.head.appendChild(stylesheet)
}
